import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Assembleia } from "../model/Assembleia";
import { AppFilter } from "app/models/app-filter.model";
import { BehaviorSubject, Observable } from "rxjs";
import AssembleiaAtaDTO from '../../../../models/assembleia/assembleiaAtaDTO.model';
import { AuthService } from "app/shared/auth/auth.service";
import { AbAssembleia } from "app/abstract/full-pages/assembleia/assembleia.abstract";

@Injectable({ providedIn: 'root' })
export class AssembleiaService extends AbAssembleia {
  prefixo = 'assembleias/';
  user: any;

  private readonly update$: BehaviorSubject<unknown> = new BehaviorSubject('')

  constructor(
    httpClient: HttpClient,
    private authService: AuthService,
  ) {
    super(httpClient);
  }

  public salvarAlterarDados(entity: Assembleia) {
    return this.save(this.prefixo, entity);
  }

  public adicionarAta(assembleiaAtaDTO: AssembleiaAtaDTO, assembleiaId: number) {
    return this.post(`${this.prefixo}${assembleiaId}/ata`, assembleiaAtaDTO)
  }

  public getAssembleias(filter: AppFilter) {
    return this.get(`${this.prefixo}filter/${filter.encode()}`);
  }

  public deleteAssembleiaById(id: number) {
    return this.delete(this.prefixo, id);
  }

  public getAssembleiaById(id: number) {
    return this.get(this.prefixo, id);
  }

  public enviarEmailNovaAssembleia(id: number) {
    return this.post(`${this.prefixo}nova_assembleia/${id}`, null);
  }

  public enviarEmailCancelamentoAssembleia(id: number) {
    return this.post(`${this.prefixo}cancelar_assembleia/${id}`, null);
  }

  public downloadArquivo(assembleiaId: number, nomeArquivo: string) {
    return this.get(`${this.prefixo}arquivo/download/${assembleiaId}/${nomeArquivo}`);
  }

  public deleteArquivo(assembleiaId: number, nomeArquivo: string) {
    return this.delete(`${this.prefixo}arquivo/delete/${assembleiaId}/${nomeArquivo}`, null);
  }

  public gerarEdital(id: number): Observable<any> {
    return this.get(`${this.prefixo}gerar_edital/${id}`);
  }

  isIntegrador(): boolean {
    this.user = this.authService.getUsuarioStorage();
    return this.user.integrador;
  }

  setAssembleiaSubject(data: Assembleia): void {
    this.update$.next(data)
  }
  getAssembleiaSubject(): Observable<unknown> {
    return this.update$.asObservable();
  }
}
